export var getAddonDiscount = function(itemRow, param) {
    var fullCost = param.fullCost;
    var ref, ref1;
    var discountAmount = (ref = itemRow.item) === null || ref === void 0 ? void 0 : ref.discountAmount;
    return discountAmount || fullCost * +(((ref1 = itemRow.item) === null || ref1 === void 0 ? void 0 : ref1.discountPercent) || 0) / 100;
};
